import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=111bcebb&scoped=true&"
import script from "./caseDetails.vue?vue&type=script&lang=js&"
export * from "./caseDetails.vue?vue&type=script&lang=js&"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=111bcebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111bcebb",
  null
  
)

export default component.exports